module.exports = __webpack_public_path__ + "img/six.fe4404f6.jpg";